import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Dbmodels } from '../../core/entities/dbmodels.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class DbmodelsService {
    readonly BASE: any = PETICIONES.dbmodels;

    constructor(private http: HttpClient) { }

    /**
   * @description
   * Obtiene todos los dbmodels
   */
  public findAll(): Observable<any> {
    return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene un dbmodels por su id
   */
  public findById(id: number): Observable<any> {
    let idbmodels: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findById + "/" + idbmodels).pipe(delay(DELAY));
  }

  /**
   * @description
   * Guarda un dbmodels en la base de datos
   */
  public postDbmodel(dbmodel: Dbmodels): Observable<any> {
    const json = JSON.stringify(dbmodel);
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.BASE.postDbmodels, json, {headers: headers}).pipe(delay(DELAY));
  }

  /**
   * @description
   * Borra un dbmodels en la base de datos
   */
  public deleteDbmodel(dbmodel: Dbmodels): Observable<any> {
    let iddbmodels: string = (dbmodel.id !== undefined && dbmodel.id !== null ? dbmodel.id + "" : "");
    return this.http.get(this.BASE.deleteDbmodels + "/" + iddbmodels).pipe(delay(DELAY));
  }

}